export const cleanHtml = (str: string) => {
    if (str === null || str === "") {
        return "";
    } else {
        str = str.toString();
    }

    return str.replace(/(<([^>]+)>)/gi, "").replace(/&#?[a-z0-9]+;/gi, "");
};
